import { getOpenPaymentAddConfig, openOpenCreditAddModal } from '../manager/open-credit-add-modal';
import { showAlertMsg } from './member-show-alert-msg.js';
import { memberRoutes as routes } from './member-nav-config.js';

export function openMemberOpenPaymentAddModal(gatewayId) {
    const $mount = $('#memberOpenPaymentAddModalMount');
    if (!$mount.length) {
        showAlertMsg('Add funds is not available on this page. Please refresh and try again.', 'danger');
        return;
    }
    if (String($mount.attr('data-creation-enabled') || '') !== '1') {
        showAlertMsg(
            $mount.attr('data-creation-disabled-message')
                || 'Open credits are disabled. Enable them in Administration → Payments.',
            'danger'
        );
        return;
    }
    if ($mount.find('#addOpenPaymentModal').hasClass('show')) {
        return;
    }

    const requestData = {};
    const limitGatewayId = parseInt(String(gatewayId || ''), 10);
    if (Number.isFinite(limitGatewayId) && limitGatewayId > 0) {
        requestData.gateway_id = limitGatewayId;
    }

    openOpenCreditAddModal($mount, {
        url: routes().memberOpenCreditAddModal,
        data: requestData,
        onReady: function ($container) {
            const cfg = getOpenPaymentAddConfig();
            if (cfg && typeof cfg === 'object') {
                cfg.afterClose = 'accountSettings';
            }
            $container.off('hidden.bs.modal.memberOpenPayAdd').on('hidden.bs.modal.memberOpenPayAdd', '#addOpenPaymentModal', function () {
                $mount.empty();
            });
            const $modal = $container.find('#addOpenPaymentModal');
            const gid = parseInt(String(gatewayId || ''), 10);
            if (Number.isFinite(gid) && gid > 0) {
                const $inp = $modal.find('.open-payment-amount-input[data-gateway-id="' + gid + '"]');
                if ($inp.length) {
                    $inp.trigger('focus');
                    return;
                }
            }
            $modal.find('#open_payment_amount').trigger('focus');
        },
    });
}
